<template lang="html">
  <div @mouseover="hover = true" @mouseleave="hover = false" class="item-wrapper">
    <item-image
      :itemImage="getItemImage"
      :hover="hover"
      :favorite="getFavorite"
      :id="itemData.pro_id"
      @details="openDetails"
      :myProduct="getMyProduct"
    />
    <item-description
      :description="itemData"
      :hover="hover"
    />
  </div>
</template>

<script>
import { baseURL } from '@/api'
import ItemDescription from '@/components/item/itemDescription.vue'
import ItemImage from '@/components/item/itemImage.vue'
export default {
  name: 'item',
  props: {
    itemData: {
      required: true,
      type: Object
    }
  },
  components: {
    ItemDescription,
    ItemImage
  },
  data () {
    return {
      hover: false
    }
  },
  activated () {
    this.hover = false
  },
  computed: {
    getItemImage () {
      if (this.itemData.pro_image) {
        return baseURL + this.itemData.pro_image
      } else {
        return require('@/assets/images/defaultItemImage.png')
      }
    },
    getFavorite () {
      return this.itemData.favorite === 1
    },
    getMyProduct () {
      return this.itemData.my_product === 1
    }
  },
  methods: {
    openDetails () {
      let params = Object.assign({}, this.$route.params)
      params.id = this.itemData.pro_id
      this.$router.push({ name: 'Details', params: params })
    }
  }
}
</script>

<style lang="scss" scoped>
.item-wrapper {
  margin-right: 30px;
  max-width: 252px;
  background: rgba(247, 247, 247, 0.92);
  border: 1px solid rgba(247, 247, 247, 0.92);
  box-sizing: border-box;
}
.item-wrapper:last-child {
  margin-right: 0px;
}
</style>
